(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const footerMobileMenuItems = document.querySelectorAll('.footer-mobile-menu-item-title');

    footerMobileMenuItems.forEach((item) => {
      item.addEventListener('click', () => {
        item.parentElement.classList.toggle('footer-mobile-menu-item-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // 统一的滚动隐藏/显示导航栏脚本 - 时间间隔控制版本
(function() {
    let lastScrollTop = 0;
    let ticking = false;
    let unifiedPlaceholder = null;
    
    // 状态控制变量
    let lastHideTime = 0;
    let lastShowTime = 0;
    const MIN_STATE_CHANGE_INTERVAL = 300; // 状态变化最小间隔300ms
    
    function init() {
        const mainContent = document.getElementById('MainContent');
        
        if (!unifiedPlaceholder) {
            unifiedPlaceholder = document.createElement('div');
            unifiedPlaceholder.className = 'nav-bars-placeholder';
            unifiedPlaceholder.style.cssText = `
                transition: height 0.3s ease;
                width: 100%;
                display: block;
                will-change: height;
                pointer-events: none;
            `;
            
            if (mainContent && mainContent.parentNode) {
                mainContent.parentNode.insertBefore(unifiedPlaceholder, mainContent);
            }
            updatePlaceholder();
        }
    }
    
    function updatePlaceholder() {
        if (!unifiedPlaceholder) return;
        
        const navBars = [
            document.querySelector('.announcement-bar-fixed'),
            document.querySelector('promotion-bar'),
            document.querySelector('.header-sticky')
        ].filter(Boolean);
        
        let totalHeight = 0;
        navBars.forEach(bar => {
            if (!bar.classList.contains('scroll-hide')) {
                const rect = bar.getBoundingClientRect();
                totalHeight += rect.height || 0;
            }
        });
        
        unifiedPlaceholder.style.height = totalHeight + 'px';
    }
    
    function setNavigationHidden(hidden) {
        const now = Date.now();
        const navBars = [
            document.querySelector('.announcement-bar-fixed'),
            document.querySelector('promotion-bar'),
            document.querySelector('.header-sticky')
        ].filter(Boolean);
        
        // 检查是否需要隐藏
        if (hidden) {
            // 如果距离上次显示时间太短，不执行隐藏
            if (now - lastShowTime < MIN_STATE_CHANGE_INTERVAL) {
                return false;
            }
            
            let anyChanged = false;
            navBars.forEach(bar => {
                if (!bar.classList.contains('scroll-hide')) {
                    bar.classList.add('scroll-hide');
                    anyChanged = true;
                }
            });
            
            if (anyChanged) {
                lastHideTime = now;
                updatePlaceholder();
                return true;
            }
        } 
        // 检查是否需要显示
        else {
            // 如果距离上次隐藏时间太短，不执行显示
            if (now - lastHideTime < MIN_STATE_CHANGE_INTERVAL) {
                return false;
            }
            
            let anyChanged = false;
            navBars.forEach(bar => {
                if (bar.classList.contains('scroll-hide')) {
                    bar.classList.remove('scroll-hide');
                    anyChanged = true;
                }
            });
            
            if (anyChanged) {
                lastShowTime = now;
                updatePlaceholder();
                return true;
            }
        }
        
        return false;
    }
    
    function handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollDelta = scrollTop - lastScrollTop;
        
        // 在页面顶部时始终显示
        if (scrollTop <= 50) {
            setNavigationHidden(false);
        } 
        // 向下滚动且超过阈值 - 隐藏导航栏
        else if (scrollDelta > 10 && scrollTop > 100) {
            setNavigationHidden(true);
        }
        // 向上滚动 - 显示导航栏
        else if (scrollDelta < -10) {
            setNavigationHidden(false);
        }
        
        lastScrollTop = scrollTop;
        ticking = false;
    }
    
    window.addEventListener('scroll', function() {
        if (!ticking) {
            window.requestAnimationFrame(handleScroll);
            ticking = true;
        }
    }, { passive: true });
    
    // 初始化
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        setTimeout(init, 100);
    }
    
    window.addEventListener('resize', function() {
        updatePlaceholder();
    }, { passive: true });
})();

// 移动端透明 Header 只在首屏 Banner 足够高时启用
(function() {
    const MOBILE_BREAKPOINT = 1080;
    const MIN_FULLSCREEN_RATIO = 0.85;

    function getTransparentHero() {
        const firstSection = document.querySelector('#MainContent > .shopify-section:first-child');
        if (!firstSection) return null;

        return firstSection.querySelector('[data-mobile-header-transparent="true"]');
    }

    function updateMobileHeaderAppearance() {
        const headerRoot = document.querySelector('.header');
        const stickyHeader = headerRoot?.querySelector('.header-sticky');
        const mobileHeader = headerRoot?.querySelector('.header-mobile');

        if (!headerRoot || !stickyHeader || !mobileHeader) return;

        const transparentHero = getTransparentHero();
        const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
        const menuOpen = headerRoot.getAttribute('data-details') === 'open';
        const nearTop = window.scrollY <= 10;
        const heroHeight = transparentHero?.getBoundingClientRect().height || 0;
        const heroIsFullscreen = heroHeight >= window.innerHeight * MIN_FULLSCREEN_RATIO;
        const shouldBeTransparent = Boolean(isMobile && transparentHero && heroIsFullscreen && nearTop && !menuOpen);

        stickyHeader.classList.toggle('is-transparent', shouldBeTransparent);
        mobileHeader.classList.toggle('is-transparent', shouldBeTransparent);
    }

    const init = () => {
        updateMobileHeaderAppearance();

        window.addEventListener('scroll', updateMobileHeaderAppearance, { passive: true });
        window.addEventListener('resize', updateMobileHeaderAppearance, { passive: true });

        const headerRoot = document.querySelector('.header');
        if (headerRoot) {
            new MutationObserver(updateMobileHeaderAppearance).observe(headerRoot, {
                attributes: true,
                attributeFilter: ['data-details']
            });
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

// 菜单悬停效果
(function() {
    const menuItems = document.querySelectorAll('.header-pc-menu-list .header-pc-menu-list-item');
    menuItems.forEach((menuItem) => {
        menuItem.addEventListener('mouseover', () => {
            menuItem.classList.add('menu-item-active');
        });

        menuItem.addEventListener('mouseout', () => {
            menuItem.classList.remove('menu-item-active');
        });
    });
})();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-related-products"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersection) return;

    observer.unobserver(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
  observer.observe(productRecommendationSection);

  } catch(e) { console.error(e); }
})();
})();
